import type { SalesOrder } from '@/lib/services/sales-orders/sales-orders.types'
import { toast } from 'sonner'

export function showFulfillmentUpdateResult(
  updatedOrder: Pick<SalesOrder, 'fulfillment_sync_warning'>,
  successMessage: string
): void {
  if (updatedOrder?.fulfillment_sync_warning) {
    toast.warning('Order marked delivered here', {
      description: updatedOrder.fulfillment_sync_warning.message,
    })
    return
  }

  toast.success(successMessage)
}
